// In-app notice and tab-title ping for the options wait.
// Email is not sent. The spec's other channel is the tab title.

export const OPTIONS_READY_KEY = "dople.options-ready.v1";
export const OPTIONS_READY_EVENT = "dople:options-ready";
export const OPTIONS_READY_TITLE = "Your options are ready";

export function readOptionsReady() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(OPTIONS_READY_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function writeOptionsReady(value) {
  if (typeof window === "undefined") return;
  try {
    if (value) window.localStorage.setItem(OPTIONS_READY_KEY, JSON.stringify(value));
    else window.localStorage.removeItem(OPTIONS_READY_KEY);
  } catch {
    // The trip record stays the source of truth if storage is blocked.
  }
  window.dispatchEvent(new CustomEvent(OPTIONS_READY_EVENT, { detail: value || null }));
}

export function announceOptionsReady() {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  if (!root.dataset.doplePriorTitle) {
    root.dataset.doplePriorTitle = document.title || "Dople: Personalized Travel Itineraries";
  }
  document.title = OPTIONS_READY_TITLE;
}

export function releaseOptionsReadyTitle() {
  if (typeof document === "undefined") return;
  const previous = document.documentElement.dataset.doplePriorTitle;
  if (previous) document.title = previous;
  delete document.documentElement.dataset.doplePriorTitle;
}

export function markOptionsReady(value) {
  const current = readOptionsReady();
  if (!current || current.stage !== "building" || String(current.tripId) !== String(value?.tripId || "")) return null;
  const ready = {
    ...current,
    ...value,
    stage: "ready",
  };
  writeOptionsReady(ready);
  announceOptionsReady();
  return ready;
}
